import { render, staticRenderFns } from "./CompaniesModalFormInfo.vue?vue&type=template&id=2b7415af&"
import script from "./CompaniesModalFormInfo.vue?vue&type=script&lang=js&"
export * from "./CompaniesModalFormInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports